import * as detection from './Detection';

export const Detection = detection;

export { BODY_ID, DESKTOP_NAV_ID } from './Elements';
